/* =========================================================================
 * Trips + Restaurant — club gating.
 *
 * Both verticals are opt-in per club, the same way Polo and Lodging are
 * (see poloAccess.ts / lodgingAccess.ts). Neither has a backend club flag
 * yet, so the gate is an explicit club-id allowlist plus an env override
 * for staging / local dev.
 *
 *   Trips      → Snow Monster (club 90)
 *   Restaurant → Sugarcane    (club 128), Modon (club 217), PadelHub VN (club 59)
 * ========================================================================= */

const TRIPS_ENABLED_CLUBS: number[] = [90];
const RESTAURANT_ENABLED_CLUBS: number[] = [128, 217, 59];

const envTrue = (v?: string) => String(v || "").toLowerCase() === "true";

const TRIPS_ENV_ENABLED = envTrue(process.env.REACT_APP_TRIPS_ENABLED);
const RESTAURANT_ENV_ENABLED = envTrue(process.env.REACT_APP_RESTAURANT_ENABLED);

/* Staging and local dev keep every vertical on so the team can build. */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const IS_DEV_BACKEND =
  BACKEND_URL.includes("devapi") ||
  BACKEND_URL.includes("localhost") ||
  BACKEND_URL.includes("127.0.0.1");

function readCurrentUser(): any {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
}

export function readCurrentClubId(): number | null {
  try {
    const user = readCurrentUser();
    const selectedClubId = Number(localStorage.getItem("Club_id"));
    if (user?.role?.name === "SUPER_ADMIN" && Number.isInteger(selectedClubId)) {
      return selectedClubId;
    }
    const clubId = Number(user?.club_id ?? user?.club?.id);
    return Number.isInteger(clubId) ? clubId : null;
  } catch {
    return null;
  }
}

export function isTripsClub(): boolean {
  if (TRIPS_ENV_ENABLED || IS_DEV_BACKEND) return true;
  const clubId = readCurrentClubId();
  return clubId != null && TRIPS_ENABLED_CLUBS.includes(clubId);
}

export function isRestaurantClub(clubId: number | string | null | undefined = readCurrentClubId()): boolean {
  if (RESTAURANT_ENV_ENABLED || IS_DEV_BACKEND) return true;
  const id = Number(clubId);
  return Number.isFinite(id) && RESTAURANT_ENABLED_CLUBS.includes(id);
}
